<template>
  <div>
    <div>
      <span>客户接待>客服状态</span>
      <el-divider></el-divider>
    </div>
    <div class="layout-page-box">
      <el-form :inline="true" label-width="80px" label-position="right" class="search-form">
        <el-form-item label="院区">
          <el-select v-model="filters.client" placeholder="请选择院区" style="width:90%">
            <el-option v-for="item in clientType" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="部门">
          <el-select v-model="filters.client" placeholder="请选择部门" style="width:90%">
            <el-option v-for="item in departmentType" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-input placeholder="请输入关键字" v-model="filters.keyword">
            <i slot="prefix" class="el-input__icon el-icon-search"></i>
          </el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="query(1)">查询</el-button>
          <el-button type="danger">删除</el-button>
          <el-button type="warning">手动刷新</el-button>
        </el-form-item>
      </el-form>
    </div>
    <!-- 主体内容 -->
    <el-tabs v-model="activeName" @tab-click="handleClick">
      <el-tab-pane label="全部(20)" name="0"></el-tab-pane>
      <el-tab-pane label="接待中(20)" name="1"></el-tab-pane>
      <el-tab-pane label="空闲(20)" name="2"></el-tab-pane>
      <el-tab-pane label="休息(20)" name="3"></el-tab-pane>
      <el-tab-pane label="禁用中(20)" name="4"></el-tab-pane>
    </el-tabs>
    <serviceChild></serviceChild>
  </div>
</template>

<script>
import serviceChild from "./serviceChild.vue";
export default {
  components: {
    serviceChild
  },
  data() {
    return {
      filters: {
        pagination: {
          page: 1,
          limit: 10,
          total: 0
        },
      },
      activeName: 0,
      multipleSelection: [],
      clientType: [{
        value: 0,
        label: '全部'
      }, {
        value: 1,
        label: '伯思立'
      }, {
        value: 2,
        label: '百达丽'
      },],
      departmentType: [{
        value: 0,
        label: '全部'
      }, {
        value: 1,
        label: '客服一部'
      }, {
        value: 2,
        label: '客服二部'
      },],
    }
  },
  methods: {

    refresh() {
      router.push({
        path: this.$route.path,
        query: _.merge({}, this.$route.query, {
          __query: JSON.stringify(this.pagination)
        }, {
            random: Math.random()
          })
      })
    },
    // tab切换事件
    handleClick(tab, event) {
      console.log(tab, event);
    },
    // 查询数据列表
    query(page) {
      var querys = {
        positionCode: this.filters.positionCode,
        positionName: this.filters.positionName,
        page: page,
        size: this.filters.pagination.limit,
      }
      api.requestQuiet('/position/findPosition', querys, (res) => {
        var data = res.data.list
        this.tableData = data
        this.orgData = data
        this.filters.pagination.total = parseInt(res.data.total)
      }, (err) => { })
    },
  },
  mounted() {
    /*this.init();*/
    this.query(this.filters.pagination.page)
  },
  watch: {
    '$route'(to, from) {
      this.query(this.filters.pagination.page)
    }
  }
}
</script>

<style scoped>
</style>